import * as React from 'react';
import { ReportViewer } from '../../reports/ReportViewer';

interface ReportWidgetProps {
    name: string;
    server: string;
    path: string;
    session: string;
    parameters: { [key: string]: string };
}

interface ReportWidgetState {
}

export default class ReportWidget extends React.Component<ReportWidgetProps, ReportWidgetState> {
    render() {
        const { name, server, path, session, parameters } = this.props;

        return (
            <div className="row">
                <div className='col-lg-6'>
                    <div className='ibox'>
                        <div className='ibox-title'>
                            <h5 className="text-primary">{name}</h5>
                        </div>
                        <ReportViewer reportServerUri={server} reportPath={path} showToolbar="false" showParameters="Collapsed" sessionId={session} parameters={parameters} />
                    </div>
                </div>
            </div>
        );
    }
}
